<template>

  <b-row>
    <b-col md="12">
      <b-card 
        no-body 
        :class="{ open: visibleBody }" 
      >
        <b-card-header 
          style="background-color: #0080C9; color: white; font:45px; padding:15px; padding: 1rem"
          :class="{ collapsed: !visibleBody }"  
          role="tab" 
          data-toggle="collapse"
          @click="() => visibleBody = !visibleBody" 
        >
          <span class="lead collapse-title"><strong>DOCUMENTOS</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down' "/>
        </b-card-header>
        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body style="padding: 1px">
            
            


            <div class="px-2 py-2 m-2" style="border: 4px dotted #c9c9c9;">
              <LoadFileInput
                label="DOCUMENTO AS 400"
                v-model="docAs400.newFile"
                :urlFile="docAs400.urlFile"
                noDelete
              />
            </div>
            

          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>
<script>

import { LoadFileInput } from '@/shared/components';
import { mapState } from 'vuex';

export default {
  
  components: {
    LoadFileInput
  },


  created() {
    this.loadData();
  },

  data() {
    return {

      visibleBody: false,

      docAs400: {
        newFile: null,
        urlFile: null,
      },
      
    }
  },

  methods: {


    async loadData(){
      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;
      // this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;
    }

    
  },

  computed: {
    ...mapState({
      stCitaDocAs400: state => state.atencionCita.dataCita?.documentoscitaSet
    }),
  },


  watch:{
    docAs400: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.$store.commit("setDocAs400", { ...newValue });
      }
    },

    stCitaDocAs400: {
      deep: true,
      handler(newValue) {
        if(!newValue) return;
        const urlFile = newValue[0].urlsDocAs400
        this.docAs400.urlFile = urlFile;
      }
    }
  }


}
</script>
